import { StatusBar } from "expo-status-bar";
import { getAuth, updateProfile } from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import {
    StyleSheet,
    Text,
    View,
    Pressable,
    Image,
    ScrollView,
    SafeAreaView,
    TextInput,
} from "react-native";
import { BaseButton } from "../components/BaseButton";
import { BaseText } from "../components/BaseText";
import { colors } from "../constants/colors";
import { logOut } from "../services/firebase/auth_email";
import { loadFonts } from "../utils/fonts";

export default function GameScreen() {
    const [inGame, setInGame] = useState(false);
    const [gameMode, setGameMode] = useState("+");
    const [currentCalculation, setCurrentCalc] = useState("");
    const [showAnswerInfo, setShowAnswerInfo] = useState(false);
    const [showEndInfo, setShowEndInfo] = useState(false);
    const [isLastAnswerCorrect, setIsLastAnswerCorrect] = useState(false);
    const [userAnswer, setUserAnswer] = useState("");
    const [correctAns, setCorrectAns] = useState(null);
    const [points, setPoints] = useState(0);
    const [correct, setCorrect] = useState(0);
    const [falseCount, setFalseCount] = useState(0);
    const [max, setMax] = useState(10);
    const inputRef = useRef(null);

    const numbers = Array.from(Array(21).keys());
    const tehted = ["+", "-", '*'];

    let fontsLoaded = loadFonts();

    const initialize = () => {
        setCorrect(0);
        setFalseCount(0);
        setPoints(0); setCurrentCalc("");
        setShowEndInfo(false);
        setShowAnswerInfo(false);
    };

    const startGame = (gameMode: string) => {
        initialize();
        setGameMode(gameMode);
        setInGame(true);
        getCalc();
        inputRef?.current?.focus();
    };

    const startAdditionGame = () => {
        startGame('+')
    }

    const startSubtractionGame = () => {
        startGame('-')
    }

    const startMultiplyGame = () => {
        startGame('*')
    }

    const startMixedGame = () => {
        startGame('+-')
    }


    const getAddition = (firstNr: number, secondNr: number) => {
        let currentCalc = String(firstNr) + " + " + String(secondNr);
        let correctAns = firstNr + secondNr;
        return [currentCalc, correctAns];
    }

    const getSubtraction = (firstNr: number, secondNr: number) => {
        let larger = Math.max(firstNr, secondNr);
        let smaller = Math.min(firstNr, secondNr);
        let currentCalc = larger + " - " + smaller;
        let correctAns = larger - smaller;
        return [currentCalc, correctAns];
    }

    const getMultiplication = (firstNr: number, secondNr: number) => {
        let currentCalc = firstNr + " x " + secondNr;
        let correctAns = firstNr * secondNr;
        return [currentCalc, correctAns];
    }

    const getRandomNumber = (max: number = 10) => {
        const numbers = Array.from(Array(max).keys());
        return numbers[Math.floor(Math.random() * numbers.length)]
    }


    const getCalc = () => {
        const maxNumber = gameMode === "+" || gameMode === "-" ? 21 : 4;
        const isMultiplication = gameMode === "*";
        var firstNr = getRandomNumber(maxNumber);
        var secondNr = getRandomNumber(isMultiplication ? 10 : maxNumber);
        let correctAns;
        let currentCalc = "";
        if (gameMode === "+") {
            [currentCalc, correctAns] = getAddition(firstNr, secondNr);
        }
        if (gameMode === "-") {
            [currentCalc, correctAns] = getSubtraction(firstNr, secondNr);
        }
        if (isMultiplication) {
            [currentCalc, correctAns] = getMultiplication(firstNr, secondNr);
        }
        if (gameMode === "+-") {
            let tehe = tehted[Math.floor(Math.random() * tehted.length)];
            if (tehe === '+') {
                [currentCalc, correctAns] = getAddition(firstNr, secondNr);
            } else {
                [currentCalc, correctAns] = getSubtraction(firstNr, secondNr);
            }
        }
        currentCalc += " = ";
        setCurrentCalc(currentCalc);
        setCorrectAns(correctAns);
    };

    const submitAnswer = () => {
        if (!userAnswer || userAnswer === "") return;
        var isCorrect = false;
        if (parseInt(userAnswer) !== correctAns) {
            setPoints(points - 1);
            setFalseCount(falseCount + 1);
            inputRef?.current?.clear();
        } else {
            isCorrect = true;
            setPoints(points + 1);
            setCorrect(correct + 1);
            inputRef?.current?.clear();
        }
        setShowAnswerInfo(true);
        setIsLastAnswerCorrect(isCorrect);

        setTimeout(() => {
            const answeredQuestions = correct + falseCount + 1;
            if (answeredQuestions === max) {
                // show end score
                setShowEndInfo(true);
            } else {
                setShowAnswerInfo(false);
                setUserAnswer("");
                getCalc();
            }
        }, 1100);
    };

    const finish = () => {
        setInGame(false);
    };

    if (!fontsLoaded)
        return (
            <View>
                <Text>Oota...</Text>
            </View>
        );

    const showCorrectBackground = showAnswerInfo && isLastAnswerCorrect;
    const showFalseBackground = showAnswerInfo && !isLastAnswerCorrect;
    const displayName = getAuth().currentUser?.displayName;

    return (
        <SafeAreaView flex={1} style={{ backgroundColor: colors.lightBlue }}>
            <StatusBar style="dark" />
            <ScrollView
                contentContainerStyle={styles.container}
                keyboardShouldPersistTaps="always"
            >
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <Image
                        style={{ width: 230, height: 40 }}
                        source={require('../assets/logo-transparent.png')} />

                    <BaseText onPress={logOut}>Logi välja</BaseText></View>
                {!inGame && (
                    <View style={{ flex: 1, marginTop: 0 }}>
                        <View
                            style={{
                                borderRadius: 15,
                                backgroundColor: colors.brightBlue,
                                padding: 16,
                                paddingVertical: 20,
                            }}
                        >
                            <Text style={{ fontSize: 22, color: "white", marginBottom: 24 }}>
                                Rõõm sind näha,{" "}
                                <Text
                                    style={{ fontSize: 24, fontFamily: "KulimPark_600SemiBold" }}
                                >
                                    {displayName}
                                </Text>
                                !
                            </Text>
                            <Text style={{ fontSize: 22, color: "white", marginBottom: 6 }}>
                                Oled juba{" "}
                                <Text
                                    style={{ fontSize: 24, fontFamily: "KulimPark_600SemiBold" }}
                                >
                                    2
                                </Text>{" "}
                                päeva järjest harjutanud!
                            </Text>
                            <Text style={{ fontSize: 22, color: "white", marginBottom: 0 }}>
                                Kõige paremini tuleb sul välja{" "}
                                <Text style={{ fontFamily: "KulimPark_600SemiBold" }}>
                                    liitmine.
                                </Text>
                            </Text>
                            {/* <Text style={{ fontSize: 22, color: "white" }}>
                Sinu skoor: 2
              </Text> */}
                        </View>
                        <View style={{ flex: 1 }}>
                            <BaseText style={{ fontSize: 18, marginVertical: 20 }}>
                                Soovitame sul täna harjutada:
                            </BaseText>
                            <BaseButton
                                containerStyle={{ backgroundColor: colors.paleGreen }}
                                text="Liitmine"
                                onPress={startAdditionGame}
                            />
                            <View style={{ borderBottomWidth: 1, borderBottomColor: colors.lightGrey, marginBottom: 10 }} />
                            <BaseText style={{ fontSize: 18, marginBottom: 20 }}>
                                Teised valikud:
                            </BaseText>
                            <BaseButton
                                containerStyle={{ backgroundColor: colors.paleBlue }}
                                text="Lahutamine"
                                onPress={startSubtractionGame}
                            />
                            <BaseButton
                                containerStyle={{ backgroundColor: colors.falseRed }}
                                text="Korrutamine"
                                onPress={startMultiplyGame}
                            />
                            <BaseButton
                                containerStyle={{ backgroundColor: colors.palePink }}
                                text="Kõik"
                                onPress={startMixedGame}
                            />
                        </View>
                    </View>
                )}
                {inGame && (
                    <View style={{ marginTop: 20 }}>
                        <View
                            style={{
                                backgroundColor: showCorrectBackground
                                    ? colors.correctGreen
                                    : showFalseBackground
                                        ? colors.falseRed
                                        : colors.lightGrey,
                                borderRadius: 15,
                                paddingVertical: 50,
                                justifyContent: "center",
                                flexDirection: "row",
                                shadowColor: colors.brightBlue,
                                shadowOffset: {
                                    width: 0,
                                    height: 4,
                                },
                                shadowOpacity: 0.3,
                                shadowRadius: 4.65,

                                elevation: 8,
                            }}
                        >
                            <Text style={{ color: colors.darkGrey, fontSize: 50 }}>
                                {showEndInfo
                                    ? "Mäng läbi"
                                    : showAnswerInfo
                                        ? isLastAnswerCorrect
                                            ? "Õige"
                                            : "Vale"
                                        : currentCalculation}
                            </Text>
                            {!showAnswerInfo && (
                                <TextInput
                                    ref={inputRef}
                                    value={userAnswer}
                                    autoFocus
                                    keyboardType="numeric"
                                    returnKeyLabel="Valmis"
                                    returnKeyType="done"
                                    onChangeText={setUserAnswer}
                                    onSubmitEditing={submitAnswer}
                                    style={{
                                        fontSize: 40,
                                        borderBottomColor: colors.brightBlue,
                                        borderBottomWidth: 1,
                                        minWidth: 60,
                                        marginLeft: 10,
                                    }}
                                />
                            )}
                        </View>
                        <BaseButton
                            containerStyle={{ marginTop: 20 }}
                            textStyle={{ color: "white" }}
                            text={showEndInfo ? "Algusesse" : "Valmis!"}
                            onPress={showEndInfo ? finish : submitAnswer}
                        />

                        <View style={{ alignSelf: "flex-start" }}>
                            <Text style={styles.tekst}>
                                Tehteid jäänud: {max - (falseCount + correct)}
                            </Text>
                            <Text style={styles.tekst}>Õigeid vastuseid: {correct}</Text>
                            <Text style={styles.tekst}>Valesid vastuseid: {falseCount}</Text>
                            <Text style={styles.tekst}>Punkte kokku: {points}</Text>
                        </View>
                        <Text
                            onPress={finish}
                            style={{ color: colors.brightBlue, fontSize: 16, marginTop: 20 }}
                        >
                            Tagasi
                        </Text>
                    </View>
                )}
            </ScrollView>
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: colors.lightBlue,
        // alignItems: 'center',
        justifyContent: "flex-start",
        paddingHorizontal: 20,
    },
    tekst: {
        fontSize: 16,
        color: colors.darkGrey,
        marginBottom: 6,
    },
});
